export default __webpack_public_path__ + "static/media/nickV.9cc342ea.png";